import { useState } from "react";

const faqs = [
  {
    question: "Le devis est-il vraiment gratuit ?",
    answer:
      "Oui, le diagnostic et le devis sont 100% gratuits et sans engagement. Le technicien se déplace à votre domicile dans le Bas-Rhin, identifie le problème et vous remet un devis détaillé. Si vous n'acceptez pas le devis, vous ne payez rien.",
  },
  {
    question: "La pièce de rechange est-elle comprise dans le tarif ?",
    answer:
      "Oui, le devis inclut la pièce de rechange nécessaire : crémone, gond, paumelle, poignée, ou mécanisme oscillo-battant. Le prix est global et comprend la pièce + la main-d'œuvre + le déplacement.",
  },
  {
    question: "Y a-t-il une majoration le soir ou le week-end ?",
    answer:
      "Nous privilégions les interventions en journée du lundi au samedi. Pour les urgences en soirée ou week-end, contactez-nous au 03 74 47 10 36. Le technicien vous informera des conditions spécifiques lors de l'appel.",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="bg-white py-10 md:py-14">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="text-center mb-10 md:mb-14">
          <p className="font-serif italic text-[#1E3A47] text-sm md:text-base mb-2">
            Questions fréquentes
          </p>
          <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-[#1E3A47] mb-4">
            FAQ — Tarifs et devis
          </h2>
        </div>

        <div className="max-w-[1280px] mx-auto space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={faq.question}
              className="border border-[#D7E0E4] rounded-2xl bg-white overflow-hidden"
            >
              <button
                type="button"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-4 md:py-5 text-left cursor-pointer"
              >
                <span className="font-serif text-base md:text-lg font-semibold text-[#1E3A47]">
                  {faq.question}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-[#1E3A47] text-xl shrink-0 transition-transform duration-300 ${
                    openIndex === i ? "rotate-180" : ""
                  }`}
                />
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === i ? "max-h-96" : "max-h-0"
                }`}
              >
                <p className="px-5 md:px-6 pb-5 text-[#243038] text-sm md:text-base leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}